/** Build tel/sms hrefs from a display or E.164 phone. Empty input stays empty. */
export function phoneHref(scheme, phone) {
    const trimmed = phone.trim();
    if (!trimmed)
        return "";
    const plus = trimmed.includes("+");
    const digits = trimmed.replace(/\D/g, "");
    if (!digits)
        return "";
    let e164 = digits;
    if (plus) {
        e164 = `+${digits}`;
    }
    else if (digits.length === 10) {
        e164 = `+1${digits}`;
    }
    else if (digits.length === 11 && digits.startsWith("1")) {
        e164 = `+${digits}`;
    }
    return `${scheme}:${e164}`;
}
export function mapsSearchHref(query) {
    return `https://maps.google.com/maps?q=${encodeURIComponent(query)}`;
}
export function mapsEmbedSrc(query) {
    return `${mapsSearchHref(query)}&output=embed`;
}
/** Fill `{name}` tokens from `vars`; unknown tokens collapse to an empty string. */
export function fillTemplate(template, vars) {
    return template.replace(/\{(\w+)\}/g, (_, key) => String(vars[key] ?? ""));
}
//# sourceMappingURL=contactLinks.js.map